import { Fragment } from 'react';
import { Row } from './box';
import type { Theme } from 'app/shopify';
import type { ResponsiveValue } from '@shopify/restyle';

interface ProgressIndicatorProps {
  index: number;
  length: number;
  activeColor?: ResponsiveValue<keyof Theme['colors'], Theme['breakpoints']>;
}

export function ProgressIndicator({ index, length, activeColor }: ProgressIndicatorProps) {
  return (
    <Row alignItems="center" gap="spacing.general.x1" justifyContent="center">
      {Array.from({ length }, (_, i) => (
        <Fragment key={i.toString()}>
          <Row
            backgroundColor={i <= index ? (activeColor ?? 'surface.tertiary') : 'surface.tertiary-neutral'}
            borderRadius="radius.lg"
            height={5}
            marginEnd="spacing.general.x0,5"
            width={50}
          />
        </Fragment>
      ))}
    </Row>
  );
}
